import script from "./Policy.vue?vue&type=script&setup=true&lang=js"
export * from "./Policy.vue?vue&type=script&setup=true&lang=js"

import "./Policy.vue?vue&type=style&index=0&id=908f475c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-908f475c"]])

export default __exports__